import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {HashtagService} from "@core/shared/services/hashtag.service";

@Injectable({
    providedIn: 'root'
})
export class HashtagItemResolver {

    constructor(
        private _hashtagService: HashtagService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._hashtagService.getItemAPI(parseInt(route.paramMap.get('id')))
    }
}
